import {
  SEND_SMS_REQUEST,
  SEND_SMS_SUCCESS,
  SEND_SMS_FAILURE,
  SEND_SMS_REQUEST_SUCCESS,
  SEND_SMS_REQUEST_FAILURE,
  
   SEND_ONE_SUCCESS,
  SEND_ONE_FAILURE,
  SET_SEND_TOTAL,
  SET_SENDING,
  RESET_SEND_PROGRESS,
} from "../types/send-sms-types";

const initialState = {
  sendSMSAccounts: [],
  loading: false,
  error: null,

  sending: false,
  total: 0,
  successCount: 0,
  failCount: 0,
  currentParty: null,
  failedList: [],
};

const sendSMSReducer = (state = initialState, action) => {
  switch (action.type) {
    case SEND_SMS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case SEND_SMS_SUCCESS: {
      return {
        ...state,
        sendSMSAccounts: Array.isArray(action?.payload) ? action.payload : [],
        loading: false,
        error: null
      };
    }
    case SEND_SMS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    // ===== progress =====
    case SET_SENDING:
      return { ...state, sending: action.payload };

    case SET_SEND_TOTAL:
      return { ...state, total: action.payload };

    case SEND_ONE_SUCCESS:
      return {
        ...state,
        successCount: state.successCount + 1,
        currentParty: action.payload.party,
      };
    case SEND_SMS_REQUEST_SUCCESS: {
      return {
        ...state,
        sendSMSAccounts: [],
        loading: false,
        error: null
      }
    }
    case SEND_ONE_FAILURE:
      return {
        ...state,
        failCount: state.failCount + 1,
        currentParty: action.payload.party,
        failedList: [
          ...state.failedList,
          { party: action.payload.party, error: action.payload.error },
        ],
      };

    case RESET_SEND_PROGRESS:
      return {
        ...state,
        sending: false,
        total: 0,
        successCount: 0,
        failCount: 0,
        currentParty: null,
        failedList: [],
      };
    default:
      return state;
  }
};

export default sendSMSReducer;
